import { configValidators } from '../validators/validator_registry';
const promotionSteps = {};
const toPromotionKey = (app, action, fromVersion, toVersion) => `${app}-${action}-${fromVersion}-${toVersion}`;
export const registerPromotion = (app, action, fromVersion, toVersion, fn) => {
    promotionSteps[toPromotionKey(app, action, fromVersion, toVersion)] = fn;
};
export const canPromote = (app, action, currentVersion, latestVersion) => {
    if (currentVersion >= latestVersion)
        return false;
    for (let v = currentVersion; v < latestVersion; v++) {
        if (!promotionSteps[toPromotionKey(app, action, v, v + 1)])
            return false;
    }
    return true;
};
export const promoteConfig = (app, action, fromVersion, toVersion, config) => {
    let current = { ...config };
    for (let v = fromVersion; v < toVersion; v++) {
        const key = toPromotionKey(app, action, v, v + 1);
        const fn = promotionSteps[key];
        if (!fn)
            throw new Error(`No promotion step for ${key}`);
        current = fn(current);
    }
    return current;
};
export const getLatestVersions = () => {
    const result = {};
    for (const key of Object.keys(configValidators)) {
        const lastDash = key.lastIndexOf('-');
        const prefix = key.slice(0, lastDash);
        const version = parseInt(key.slice(lastDash + 1), 10);
        if (!result[prefix] || version > result[prefix]) {
            result[prefix] = version;
        }
    }
    return result;
};
//# sourceMappingURL=promotion-registry.js.map